import { Alert, Button, Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import CellHeadings from '../CellHeadings';

export function MatchSelection({
  awayTeamId,
  competitionId,
  homeTeamId,
  onMatchSelection,
  seasonId,
  sport,
}) {
  const intl = useIntl();

  const [matchDataError, setMatchDataError] = useState('');
  const [matchesForSelection, setMatchesForSelection] = useState([]);
  const { get, isFetching, errorMessage } = useApi();

  useEffect(() => {
    async function getMatches() {
      setMatchDataError('');
      setMatchesForSelection([]);
      if (homeTeamId && awayTeamId && competitionId && seasonId) {
        const response = await get(
          `${API_ENDPOINTS.videoService}/data/${sport}/competitions/${competitionId}/seasons/${seasonId}/matches`,
        );

        const matchData = response?.data?.filter(
          (match) =>
            match.away_team.away_team_id.toString() === awayTeamId.toString() &&
            match.home_team.home_team_id.toString() === homeTeamId.toString(),
        );

        if (matchData?.length < 1) {
          setMatchDataError(
            intl.formatMessage({
              defaultMessage: 'No matches found between these teams',
              id: '579e3',
            }),
          );
        } else {
          setMatchesForSelection(matchData);
        }
      }
    }
    getMatches();
  }, [homeTeamId, awayTeamId]);

  const handleMatchSelection = async (selectedMatchId) => {
    onMatchSelection(selectedMatchId);
  };

  return (
    <>
      {errorMessage && <Alert type="error">{errorMessage}</Alert>}
      {matchDataError && <Alert type="error">{matchDataError}</Alert>}
      <Table size="small" aria-label="Matches to select from">
        <CellHeadings
          cells={[
            {
              children: intl.formatMessage({
                defaultMessage: 'Match Date',
                id: '9fabd',
              }),
              id: 'date',
            },
            {
              children: intl.formatMessage({
                defaultMessage: 'Actions',
                id: '06df3',
              }),
              id: 'actions',
            },
          ]}
          textAlign="left"
        />
        <Table.Body>
          {matchesForSelection?.map((match) => (
            <Table.Row key={`row-${match.match_id}`}>
              <Table.DataCell $textAlign="left">
                {intl.formatDate(match.match_date)}
              </Table.DataCell>
              <Table.DataCell>
                <div data-testid={match.match_id}>
                  <Button
                    onClick={() => handleMatchSelection(match.match_id)}
                    isPending={isFetching}
                    size="small"
                  >
                    <FormattedMessage defaultMessage="Use" id="ad878" />
                  </Button>
                </div>
              </Table.DataCell>
            </Table.Row>
          ))}
          {!matchesForSelection ||
            (matchesForSelection.length < 1 && (
              <Table.Row key="empty-row">
                <Table.DataCell colSpan={2}>
                  <FormattedMessage
                    defaultMessage="Matches for selection will appear here"
                    id="5b71d"
                  />
                </Table.DataCell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </>
  );
}

MatchSelection.propTypes = {
  awayTeamId: PropTypes.number,
  competitionId: PropTypes.number,
  homeTeamId: PropTypes.number,
  onMatchSelection: PropTypes.func.isRequired,
  seasonId: PropTypes.number,
  sport: PropTypes.string.isRequired,
};

MatchSelection.defaultProps = {
  awayTeamId: null,
  competitionId: null,
  homeTeamId: null,
  seasonId: null,
};

export default { MatchSelection };
